import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  useRef,
} from "react"
import { Col, Container, Row } from "reactstrap"
import { Dialog } from "primereact/dialog"
import { Checkbox } from "primereact/checkbox"
import { Dropdown } from "primereact/dropdown"
import { Tooltip } from "primereact/tooltip"
import { FileUpload } from "primereact/fileupload"
import { Chips } from "primereact/chips"
import { InputText } from "primereact/inputtext"
import { Editor } from "primereact/editor"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { CascadeSelect } from "primereact/cascadeselect"
import { Button } from "primereact/button"
import axios from "axios"
import { getBase64 } from "utils/CommonFunctions"
import { Toast } from "primereact/toast"
import { ChevronDownIcon } from "primereact/icons/chevrondown"
import { ChevronRightIcon } from "primereact/icons/chevronright"
const EmailContact = forwardRef(({ selectedCustomers }, ref) => {
  const userInfo = JSON.parse(sessionStorage.getItem("atsuser-info"))
  const userEmail = userInfo?.user_details?.email
  const [canto, setCanto] = useState([])
  const [totalRecords, setTotalRecords] = useState(0)
  const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 })
  const [formErrors, setFormErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const fileUploadRef = useRef("")
  const toast = useRef("")
  const [templateBody, setTemplateBody] = useState("")
  const [signatureText, setSignatureText] = useState("")
  const baseURL = process.env.REACT_APP_URL
  const [jobssearchedpopup, SetJobssearchedPopup] = useState(false)
  const [jobsselectedpopup, SetJobsselectedPopup] = useState(false)
  const [jobsallpopup, SetJobsallPopup] = useState(false)
  const [primaryFromEmail, setPrimaryFromEmail] = useState("")
  const [showNoSubjectConfirm, setShowNoSubjectConfirm] = useState(false)

  const [modalType, setModalType] = useState("")
  useImperativeHandle(ref, () => ({
    openModal: type => setModalType(type),
  }))

  const closeModal = () => setModalType("")

  const [defaultSignature, setDefaultSignature] = useState("")

  

  // Fetch default signature from API
  const fetchDefaultSignature = async () => {
    try {
      const response = await axios.get(`/api/v1/email-signatures/default/`)
      if (
        response.data &&
        Array.isArray(response.data) &&
        response.data.length > 0 &&
        response.data[0].signature_text
      ) {
        setDefaultSignature(response.data[0].signature_text) // Use signature_text from response
      }
    } catch (error) {
      console.error("Error fetching default signature:", error)
      setDefaultSignature("") // Fallback signature on error
    }
  }

  const [emailtextEditor, setEmailtextEditor] = useState("")

  // Fetch default signature on component mount
  useEffect(() => {
    fetchDefaultSignature()
  }, [])

  // useEffect(() => {
  //     if (defaultSignature) {
  //         setEmailtextEditor(`
  //   <p>Dear [Candidate Name],</p>
  //   <br />
  //   <p>I hope this email finds you well. Thank you for your interest in joining our team at Varun Digital Media.</p>
  //   <br />
  //   <p>[Email Body]</p>
  //   <br />
  //      <p>We look forward to your response.</p>

  //   <br/>
  //   ${defaultSignature}
  // `);
  //     }
  // }, [defaultSignature]);

  useEffect(() => {
    if (jobsallpopup || jobssearchedpopup || jobsselectedpopup) {
      // For Jobs dialogs, jobDescriptions is managed by handleSave
      return
    }
    const defaultEmailBody = `
    <p>Dear {{contact_name}},</p>
  `
    const finalEmailBody = `${templateBody || defaultEmailBody}<br /><br />${
      signatureText || defaultSignature
    }`
    // || `<br><br><p>Best Regards, <br>Varun Digital Media <br>Ph: +91-917 711 1156</p>`}`;
    setEmailtextEditor(finalEmailBody.trim())
  }, [
    templateBody,
    signatureText,
    defaultSignature,
    jobsallpopup,
    jobssearchedpopup,
    jobsselectedpopup,
  ])
  // interview

  const [primarySkillsvalu, setprimarySkillsvalu] = useState([])
  const getprimary = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CONDIDATES}/api/v1/skills/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (response.data && response.data.results) {
        const treeData = response.data.results

        setprimarySkillsvalu(treeData)
      }
    } catch (error) {}
  }

  const [city, setCity] = useState("")
  const [fullName, setFullName] = useState("")
  const [jobTitle, setJobTitle] = useState("")
  const [company, setCompany] = useState("")
  const [userIds, setUserIds] = useState("")
  const [availabilityDate1, setavailabilityDate1] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [workEmail, setWorkEmail] = useState("")
  const [documents, setDocuments] = useState([])
  const [description, setDescription] = useState("")

  const [addCities, setaddCities] = useState([])

  const getcity = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Jobs}/api/v1/cities/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      // Transform data if needed to match the Dropdown format
      const transformedData = response.data.results.map(city => ({
        name: city.name,
        code: city.city_id,
      }))
      setaddCities(transformedData)
    } catch (error) {}
  }

  useEffect(() => {
    getcity()
  }, [])

  useEffect(() => {
    getprimary()
  }, [])

  const [alljobs, setAllJobs] = useState([])
  const [jobsLazyParams, setJobsLazyParams] = useState({ page: 0, rows: 10 })
  const [totalJobsRecords, setTotalJobsRecords] = useState(0)

  const getjobs = async (page, size) => {
    try {
      const response = await axios.get(
        `/api/v1/jobs/?page=${page + 1}&size=${size}&status=Approved / Open`,
      )
      setAllJobs(response.data.results)
      setTotalJobsRecords(response.data.count || 0)
    } catch (error) {
      console.error("Error fetching jobs:", error)
    }
  }

  const getallactivecontacts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/api/v1/contacts/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const transformedData = response.data.results.map(city => ({
        name: city.first_name,
        id: city.contact_id,
      }))
      settypeInterviewcontact(transformedData)
    } catch (error) {}
  }
  const [interviewdroptype, setinterviewdroptype] = useState([])

  const getallinterviewdrop = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Calendar}/api/v1/event-lookup/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const data = response.data
      const types = data.Types.map(type => ({
        label: type,
      }))
      if (response.data === 500) {
      }

      setinterviewdroptype(types)
    } catch (error) {}
  }

  const getAllActive = async (page, size) => {
    try {
      const endpoint = `/api/v1/contacts/?page=${page + 1}&size=${size}&status=Active`

      const response = await axios.get(endpoint)
      // const response = await axios.get(`/api/v1/candidates${selectedType ? '/' + selectedType : ''}/?${param ? param + '&' : ''}page=${page + 1}&size=${size}`,);
      if (response.status === 200) {
        const jobs = response.data.results || []
        setCanto(jobs)
        setTotalRecords(response.data.count || 0)
      } else {
        setCanto([])
        setTotalRecords(0)
      }
    } catch (error) {
      console.error("Failed to fetch candidates", error)
    }
  }

  useEffect(() => {
    getjobs(jobsLazyParams.page, jobsLazyParams.rows)
    getallactivecontacts()
    getallinterviewdrop()
  }, [jobsLazyParams])
  const onJobsPageChange = event => {
    setJobsLazyParams({ page: event.page, rows: event.rows })
  }

  useEffect(() => {
    getAllActive(lazyParams.page, lazyParams.rows)
  }, [lazyParams])

  // new email
  // dialog with footer

  const [privateChecked, setPrivateChecked] = useState(false)

  const footerContent = (
    <div>
      <div className="d-flex align-items-center">
        <Checkbox
          inputId="checkbox"
          checked={privateChecked}
          onChange={e => setPrivateChecked(e.checked)}
          // checked={popchecked}
          // onChange={handlePopupCheckbox}
        />
        <label htmlFor="username" className="ms-2 mt-1">
          Private
        </label>
      </div>
    </div>
  )

  const [emailviewpop, SetEmailviewpop] = useState(false)

  const [emailviewpopSelected, SetEmailviewpopSelected] = useState(false)

  const [emailviewpopSearched, SetEmailviewpopSearched] = useState(false)

  const [emailviewpopAll, SetEmailviewpopAll] = useState(false)

  const handleSignatureChange = async e => {
    const signatureId = e.value?.id

    // Cancel previous signature request
    if (signatureAbortController.current) {
      signatureAbortController.current.abort()
    }
    signatureAbortController.current = new AbortController()
    const { signal } = signatureAbortController.current

    try {
      if (!signatureId) {
        setSelectedSignature(null)
        setSignatureText("")
        return
      }

      const response = await axios.get(
        `/api/v1/email-signatures/${signatureId}/`,
        { signal }
      )
      if (response?.data) {
        const { signature_text } = response.data
        setSelectedSignature(e.value)
        setSignatureText(signature_text || "")
      }
    } catch (error) {
      if (error.name === "AbortError") return // Ignore aborted requests
      console.error("Error fetching signature:", error)
      setSelectedSignature(null)
      setSignatureText("")
    }
  }
  const selectedSmsTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-comment mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const smsOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  const [smsOptions1, setsmsOptions1] = useState([])

  const [uploadedFiles, setUploadedFiles] = useState([])

  const onUploadHandler1 = async e => {
    const newError = {}

    const maxSize = 10 * 1024 * 1024 // 10MB

    const programmingFileExtensions = [
      ".js",
      ".ts",
      ".tsx",
      ".jsx",
      ".java",
      ".py",
      ".cpp",
      ".c",
      ".cs",
      ".rb",
      ".php",
      ".go",
      ".rs",
      ".swift",
      ".kt",
      ".sh",
      ".pl",
      ".html",
      ".xml",
    ]

    const newFiles = e.files || []

    const validFiles = await Promise.all(
      newFiles.map(async file => {
        const fileName = file.name.toLowerCase()

        // ❌ Block programming files by extension
        if (programmingFileExtensions.some(ext => fileName.endsWith(ext))) {
          newError.attachment = `Programming files are not allowed: ${file.name}`
          setFormErrors(...prev, newError)
          return ""
        }

        // ❌ Block large files
        if (file.size > maxSize) {
          newError.attachment = `File "${file.name}" exceeds 10MB size limit.`
          setFormErrors(...prev, newError)
          return ""
        }

        const base64 = await getBase64(file)
        return {
          file_name: file.name,
          file_data: base64,
        }
      })
    )

    const filteredFiles = validFiles.filter(Boolean)

    if (filteredFiles.length === 0) return

    setAttachmentfile(prevFiles => [...prevFiles, ...filteredFiles])
    setFormErrors("") // ✅ Clear any error

    // ✅ Clear upload component if needed
    if (fileUploadRef.current) {
      fileUploadRef.current.clear() // ✅ This resets the input value, allowing re-uploads
    }
  }

  // const removeFile = (fileName) => {
  //     setUploadedFiles(uploadedFiles.filter((file) => file.name !== fileName));
  // };

  const [frominputemail, setFrominputemail] = useState("")

  const [frominputemail1, setFrominputemail1] = useState("")

  const [frominputemail2, setFrominputemail2] = useState("")

  // new email form

  const Fromemailcont = item => {
    return (
      <div>
        <span>{item}</span>
      </div>
    )
  }

  const [tonewemail, setTonewemail] = useState([])
  const [toemailSelected, setToemailSelected] = useState([])
  const [ccemailSelected, setCcemailSelected] = useState([])
  const [toemailSearched, setToemailSearched] = useState([])
  const [ccemailSearched, setCcemailSearched] = useState([])

  const [ccemail, setCcemail] = useState([])
  const [subject, setSubject] = useState("")
  const Ccemailcont = item => {
    return (
      <div>
        <span>{item}</span>
      </div>
    )
  }

  const [attachmentfile, setAttachmentfile] = useState([])
  const fileListRef = useRef("")

  // const [emailtextEditor, setEmailtextEditor] = useState(`
  //      <p>Dear [Candidate Name],</p>
  //      <br />
  //      <p>I hope this email finds you well. Thank you for your interest in joining our team at Varun Digital Media.</p>
  //      <br />
  //      <p>[Email Body]</p>
  //      <br />
  //      <p>We look forward to your response.</p>
  //      <br />
  //      <p>Best regards,<br />
  //      Harish Jaram<br />
  //      Senoir HR Recruiter<br />
  //      Varun Digital Media<br />
  //      Ph: +91-98765343210</p>
  //    `)

  // jobs all strats

  const [jobDetailsVisible, setJobDetailsVisible] = useState(false)
  const [selectedJobTitles, setSelectedJobTitles] = useState("")
  const [searchText, setSearchText] = useState("")
  const [selectedJobs, setSelectedJobs] = useState([])
  const [jobLinks, setJobLinks] = useState([])
  const [jobDescriptions, setJobDescriptions] = useState("")
  useEffect(() => {
    if (jobsallpopup || jobssearchedpopup || jobsselectedpopup) {
      handleSave()
    }
  }, [
    templateBody,
    signatureText,
    selectedJobs,
    jobsallpopup,
    jobssearchedpopup,
    jobsselectedpopup,
  ])

  const filteredJobs = alljobs.filter(job => {
    const searchTextLower = searchText.toLowerCase().trim()
    const jobTitle = job.job_title ? job.job_title.toLowerCase() : ""
    const hiringManagerName = job.hiring_manager_name
      ? job.hiring_manager_name.toLowerCase()
      : ""
    const jobId = job.job_number ? job.job_number.toString() : ""

    return (
      jobTitle.includes(searchTextLower) ||
      hiringManagerName.includes(searchTextLower) ||
      jobId.includes(searchTextLower)
    )
  })

  const generateLinksForJobs = async (jobNumbers = []) => {
    try {
      const token = sessionStorage.getItem("token")
      const userInfo = JSON.parse(sessionStorage.getItem("atsuser-info"))
      const companyId = userInfo?.user_details?.company_id
      const url = `/api/v1/apply-job/generate-links/`
      const response = await axios.post(
        url,
        { job_numbers: jobNumbers, company_id: companyId },
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "application/json",
          },
        }
      )

      if (response?.data?.links) {
        setJobLinks(response.data.links)
        return response.data.links
      }
      setJobLinks([])
      return []
    } catch (error) {
      console.error("Failed to fetch generate-links:", error)
      setJobLinks([])
      return []
    }
  }

  const handleSave = async () => {
    const defaultText = `Dear {{contact_name}}, <br><br>
  We have job openings matching your skills. Please find the jobs listed below:`

    // Try to fetch signed links for selected jobs
    let linksArray = []
    try {
      const jobNumbers = selectedJobs.map(j => j.job_number).filter(Boolean)
      if (jobNumbers.length > 0) {
        linksArray = await generateLinksForJobs(jobNumbers)
      }
    } catch (err) {
      console.error("Error generating links for jobs", err)
      linksArray = []
    }

    // Fallback: if API didn't return links, map selectedJobs into a minimal structure
    if (!linksArray || linksArray.length === 0) {
      linksArray = selectedJobs.map(job => ({
        job_number: job.job_number,
        signed_link: `${baseURL}apply-job/get-job/${job.job_number}/`,
        expires_in_hours: null,
        job_details: job,
      }))
    }

    const formattedJobDetails = linksArray
      .map(link => {
        const job = link.job_details || {}
        const jobNum = job.job_number || link.job_number || ""
        const title = job.job_title || ""
        const location = job.location_name || job.location || "N/A"
        const jobType = job.job_type_name || ""
        const primarySkills = job.required_skill_names || job.required_skills || "N/A"
        const experience = job.required_experience || 0
        const description = job.job_description || "N/A"
        const signedLink = link.signed_link || `${baseURL}apply-job/get-job/${jobNum}`

        return `
    <table border="1" cellpadding="5" cellspacing="0" style="width:100%;border-collapse:collapse;border:1px solid #333;font-family:Arial,sans-serif;font-size:14px;">
        <tr>
            <td style="background:#f5f5f5;border:1px solid #333;padding:8px;text-align:left; width:25%;"><b> Job Title </b></td>
            <td style="border:1px solid #333;padding:8px; width:75%;">${title} (${jobNum})</td>
        </tr>
        <tr>
            <td style="background:#f5f5f5;border:1px solid #333;padding:8px;text-align:left; width:25%;"><b> Location </b></td>
            <td style="border:1px solid #333;padding:8px; width:75%;">${location}</td>
        </tr>
        <tr>
            <td style="background:#f5f5f5;border:1px solid #333;padding:8px;text-align:left; width:25%;"><b> Job Type </b></td>
            <td style="border:1px solid #333;padding:8px; width:75%;">${jobType}</td>
        </tr>
        <tr>
            <td style="background:#f5f5f5;border:1px solid #333;padding:8px;text-align:left; width:25%;"><b> Primary Skills </b></td>
            <td style="border:1px solid #333;padding:8px; width:75%;">${primarySkills}</td>
        </tr>
        <tr>
            <td style="background:#f5f5f5;border:1px solid #333;padding:8px;text-align:left; width:25%;"><b> Work Experience </b></td>
            <td style="border:1px solid #333;padding:8px; width:75%;">${experience} Years</td>
        </tr>
        <tr>
            <td style="background:#f5f5f5;border:1px solid #333;padding:8px;text-align:left; width:25%;"><b> Job Description </b> </td>
            <td style="border:1px solid #333;padding:8px; width:75%; word-wrap: break-word; white-space: normal;">${description}</td>
        </tr>
            <tr>
            <td style="background:#f5f5f5;border:1px solid #333;padding:8px;text-align:left; width:25%;"><b> Apply Job </b> </td>
            <td style="border:1px solid #333;padding:8px; width:75%;"><a href="${signedLink}" title="${signedLink}">Click here to submit resume!</a></td>
        </tr>
    </table><br><br>
`
      })
      .join("")

    const templateContent = templateBody ? `<br>${templateBody}<br>` : ""
    const signature =
      signatureText ||
      defaultSignature ||
      `<br><br><p>Best Regards, <br>Varun Digital Media <br>Ph: +91-917 711 1156</p>`

    const finalText = `${defaultText}<br/><br/>${formattedJobDetails}${templateContent}${signature}`
    setJobDescriptions(finalText)
    setSelectedJobTitles(selectedJobs.map(job => job.job_title).join(", "))
  }

  const handleRefresh = () => {
    setSelectedJobs([])
    setSearchText("")
    setJobDetailsVisible(false)
  }

  // popup
  // const [jobsallpopup, SetJobsallPopup] = useState(false)
  // const [jobssearchedpopup, SetJobssearchedPopup] = useState(false)
  // const [jobsselectedpopup, SetJobsselectedPopup] = useState(false)

  const handleOpenDialogs = () => {
    // Open the first dialog
    SetJobsallPopup(true)

    // Automatically open the second dialog after a short delay
    setTimeout(() => {
      setJobDetailsVisible(true)
    }, 300) // Adjust delay as needed (300ms in this example)
  }

  const handleSearchedDialogs = () => {
    // Open the first dialog
    SetJobssearchedPopup(true)

    // Automatically open the second dialog after a short delay
    setTimeout(() => {
      setJobDetailsVisible(true)
    }, 300) // Adjust delay as needed (300ms in this example)
  }

  const handleSelectedDialogs = () => {
    // Open the first dialog
    SetJobsselectedPopup(true)

    // Automatically open the second dialog after a short delay
    setTimeout(() => {
      setJobDetailsVisible(true)
    }, 300) // Adjust delay as needed (300ms in this example)
  }

  // jobs all ends

  // jobs all chip starts
  const [toemailjobs, setToemailjobs] = useState([
    "All Candidates",
    // "Michael Chris (test2@gmail.com)",
  ])
  const [ccemailjobsall, setCcemailjobsall] = useState([])
  const [toemailseljobs, setToemailseljobs] = useState([])
  const [toemailsearchjobs, setToemailsearchjobs] = useState([])
  const [ccemailjobssear, setCcemailjobssear] = useState([])
  const [ccemailjobsSearched, setCcemailjobsSearched] = useState([])

  const [fromemailjobsSelectedTo, setFromemailjobsSelectedTo] = useState([])
  const [fromemailAll, setFromemailAll] = useState([
    "All Candidates (allcandidates@gmail.com)",
  ])
  const [ccemailall, setCcemailall] = useState([])

  const [fromemailjobs, setFromemailjobs] = useState([])
  const Fromemailcontjobs = item => {
    return (
      <div>
        <span>{item}</span>
      </div>
    )
  }

  const Ccemailcontjobs = item => {
    return (
      <div>
        <span>{item}</span>
      </div>
    )
  }
  // jobs all chip ends

  // email dropdown

  const [selectedActEmail, setSelectedActEmail] = useState("")
  const actEmailOptions = [
    {
      name: "New Email",
      code: "EM-NE",
      action: () => SetEmailviewpop(true),
    },
    {
      name: "Selected",
      code: "EM-SE",
      action: () => {
        // Populate toemailSelected with candidate_email from selectedCustomers
        const emails = selectedCustomers
          .map(candidate => candidate.email)
          .filter(email => email)
        setToemailSelected(emails)
        SetEmailviewpopSelected(true)
      },
    },
    {
      name: "Searched",
      code: "EM-SC",
      action: () => SetEmailviewpopSearched(true),
    },
    {
      name: "All",
      code: "EM-AL",
      action: () => SetEmailviewpopAll(true),
    },
    {
      name: "Jobs",
      code: "EM-JO",
      subItems: [
        { name: "All", code: "EM-JO-AL" }, // "All" under Jobs
        { name: "Searched", code: "EM-JO-SE" },
        {
          name: "Selected",
          code: "EM-JO-SM",
        },
      ],
    },
  ]

  useImperativeHandle(ref, () => ({
    openModal: type => {
      if (primaryFromEmail) {
        setFrominputemail(primaryFromEmail)
        setFromemailjobs([primaryFromEmail])
        setFromemailjobsSelectedTo([primaryFromEmail])
        setFromemailAll([primaryFromEmail])
      }
      switch (type) {
        case "new":
          SetEmailviewpop(true)
          break
        case "selected":
          const emails = selectedCustomers.map(c => c.email).filter(Boolean)
          setToemailSelected(emails)
          SetEmailviewpopSelected(true)
          break
        case "searched":
          SetEmailviewpopSearched(true)
          break
        case "all":
          SetEmailviewpopAll(true)
          break
        case "jobs-selected":
          SetJobsselectedPopup(true)
          setTimeout(() => {
            setJobDetailsVisible(true)
          }, 300)
          break
        case "jobs-searched":
          SetJobssearchedPopup(true)
          setTimeout(() => {
            setJobDetailsVisible(true)
          }, 300)
          break
        case "jobs-all":
          SetJobsallPopup(true)
          setTimeout(() => {
            setJobDetailsVisible(true)
          }, 300)
          break
        default:
          break
      }
    },
  }))

  const handleEmailChange = e => {
    setSelectedActEmail(e.value)

    // Check for specific subItems like "All"
    if (e.value?.code === "EM-JO-AL") {
      // console.log("All clicked!") // Debug log
      handleOpenDialogs(true) // Open dialog
    } else if (e.value?.code === "EM-JO-SM") {
      // Populate toemailseljobs with candidate_email from selectedCustomers for Jobs > Selected
      const emails = selectedCustomers
        .map(candidate => candidate.email)
        .filter(email => email)
      setToemailseljobs(emails)
      if (emails.length > 0) {
        setToemailseljobs(emails)
        SetJobsselectedPopup(true)
        setTimeout(() => {
          setJobDetailsVisible(true)
        }, 300)
      } else {
        SetJobsselectedPopup(true) // Show fallback dialog
      }
      // handleSelectedDialogs(true) // Handle top-level actions if defined
    } else if (e.value?.code === "EM-JO-SE") {
      handleSearchedDialogs(true)
    } else if (e.value?.action) {
      e.value.action() // Handle top-level actions if defined
    }

    if (e.value?.code === "EM-SE" || e.value?.code === "EM-JO-SM") {
      const selectedEmails = selectedCustomers.map(candidate => ({
        ...candidate,
        email: candidate.email,
      }))
      setSelectedCanto(selectedEmails)
      // setLinkCantoVisible(true);
    }
    // setLinkCantoVisible(true);
  }

  // email banner starts
  const [selectedTemplate, setSelectedTemplate] = useState("")
  const [selectedSmsOption, setSelectedSmsOption] = useState("")

  const [templateOptions, setTemplateOptions] = useState([])
  const [signatureOptions, setSignatureOptions] = useState([])

  const gettemplateitems = async () => {
    try {
      const response = await axios.get(`/api/v1/email-templates/`, {})
      // console.log("gettemplateitems", response)
      const transformedData = response.data.map(city => ({
        label: city.name,
        id: city.template_id,
        body: city.body,
      }))
      setTemplateOptions(transformedData)
    } catch (error) {
      setTemplateOptions([])
    }
  }

  const getsignatureitems = async () => {
    try {
      const response = await axios.get(`/api/v1/email-signatures/`, {})
      const transformedData = response.data.map(city => ({
        label: city.name,
        id: city.signature_id,
        is_default: city.is_default || false,
      }))
      transformedData.sort((a, b) => b.is_default - a.is_default)

      setSignatureOptions(transformedData)
    } catch (error) {}
  }

  const [fromEmail, setfromEmail] = useState([])
  const fetchFromMails = async () => {
    try {
      const response = await axios.get(`/api/v1/smtp-accounts/`, {})
      const transformedData = response.data.results.map(item => ({
        name: item.from_email, // Display name for dropdown
        code: item.from_email,
      }))
      setfromEmail(transformedData)
    } catch (error) {
      console.error("Error fetching states:", error)
    }
  }

  const [selectedSignature, setSelectedSignature] = useState("")

  // email banner ends

  // candidates to popup starts

  const [linkCantoVisible, setLinkCantoVisible] = useState(false)
  const [selectedCanto, setSelectedCanto] = useState([])

  // const filteredCanto = canto?.filter((candidate) => {
  //     const fullName = `${candidate.first_name || ""} ${candidate.last_name || ""}`.toLowerCase();

  //     return (
  //         candidate.job_title?.toLowerCase().includes(searchText.toLowerCase()) ||
  //         fullName.includes(searchText.toLowerCase()) || // <-- combined name check
  //         candidate.email?.toLowerCase().includes(searchText.toLowerCase()) ||
  //         candidate.candidate_id?.toString().includes(searchText)
  //     );
  // });

  const filteredCanto = data =>
    data.filter(item => {
      const searchTextLower = searchText.toLowerCase().trim()
      const fullName = `${item.first_name || ""} ${
        item.last_name || ""
      }`.toLowerCase()
      const jobTitle = item.job_title ? item.job_title.toLowerCase() : ""
      const email = item.email ? item.email.toLowerCase() : ""
      const candidateId = item.id ? item.id.toString() : ""

      return (
        fullName.includes(searchTextLower) ||
        jobTitle.includes(searchTextLower) ||
        email.includes(searchTextLower) ||
        candidateId.includes(searchTextLower)
      )
    })

  // const handleSaveCanto = () => {
  //     const canDetails = selectedCanto.map((candidate) => ({
  //         name: candidate.first_name + " " + candidate.last_name,
  //         email: candidate.email,
  //     }));
  //     const formattedCandidates = canDetails.map(
  //         (contact) => contact.email
  //     );
  //     setTonewemail(prev => [...prev, ...formattedCandidates]);
  //     setToemailSelected(prev => [...prev, ...formattedCandidates]);
  //     setToemailSearched(prev => [...prev, ...formattedCandidates]);
  //     setFromemailAll(prev => [...prev, ...formattedCandidates]);
  //     setToemailjobs(prev => [...prev, ...formattedCandidates]);
  //     setToemailseljobs(prev => [...prev, ...formattedCandidates]);
  //     setToemailsearchjobs(prev => [...prev, ...formattedCandidates]);
  //     setLinkCantoVisible(false);
  // };

  const handleSaveCanto = () => {
    const canDetails = selectedCanto.map(candidate => ({
      name: `${candidate.first_name} ${candidate.last_name}`,
      email: candidate.email,
    }))

    const newEmails = canDetails
      .map(contact => contact.email)
      .filter(email => email?.trim())

    const mergeUnique = (prev, incoming) => {
      const emailSet = new Set([...prev, ...incoming])
      return Array.from(emailSet)
    }

    setTonewemail(prev => mergeUnique(prev, newEmails))
    setToemailSelected(prev => mergeUnique(prev, newEmails))
    setToemailSearched(prev => mergeUnique(prev, newEmails))
    setFromemailAll(prev => mergeUnique(prev, newEmails))
    setToemailjobs(prev => mergeUnique(prev, newEmails))
    setToemailseljobs(prev => mergeUnique(prev, newEmails))
    setToemailsearchjobs(prev => mergeUnique(prev, newEmails))

    setLinkCantoVisible(false)
    setSelectedCanto([]) // Clear selected candidates
    setSearchText("") // Clear search text
  }

  const handleRefresh1to = () => {
    setSelectedCanto([]) // Reset selected contacts
    setSearchText("") // Reset search text
  }

  // candidates to popup ends

  // candidates cc popup starts

  const [linkCanccVisible, setLinkCanccVisible] = useState(false)
  const [selectedCancc, setSelectedCancc] = useState([])

  const filteredCancc = canto?.filter(candidate => {
    const fullName = `${candidate.first_name || ""} ${
      candidate.last_name || ""
    }`.toLowerCase()

    return (
      candidate.job_title?.toLowerCase().includes(searchText.toLowerCase()) ||
      fullName.includes(searchText.toLowerCase()) || // <-- combined name check
      candidate.email?.toLowerCase().includes(searchText.toLowerCase()) ||
      candidate.id?.toString().includes(searchText)
    )
  })
  // const handleSaveCancc = () => {
  //     const canDetails = selectedCancc.map((candidate) => ({
  //         name: candidate.first_name + " " + candidate.last_name,
  //         email: candidate.email,
  //     }));
  //     const formattedCandidates = canDetails.map(
  //         (candidate) => `${candidate.name} - (${candidate.email})`
  //     );
  //     setCcemail(prev => [...prev, ...formattedCandidates]);
  //     setCcemailSelected(prev => [...prev, ...formattedCandidates]);
  //     setCcemailSearched(prev => [...prev, ...formattedCandidates]);
  //     setCcemailall(prev => [...prev, ...formattedCandidates]);
  //     setCcemailjobsall(prev => [...prev, ...formattedCandidates]);
  //     setCcemailjobsSearched(prev => [...prev, ...formattedCandidates]);
  //     setCcemailjobssear(prev => [...prev, ...formattedCandidates]);
  //     setLinkCanccVisible(false);
  // };

  const handleSaveCancc = () => {
    const canDetails = selectedCancc.map(candidate => ({
      name: `${candidate.first_name} ${candidate.last_name}`,
      email: candidate.email,
    }))

    const formattedCandidates = canDetails.map(
      candidate => `${candidate.email}`
    )

    // Helper to remove duplicates from merged array
    const mergeUnique = (prev, newItems) => {
      const set = new Set(prev)
      newItems.forEach(item => set.add(item))
      return Array.from(set)
    }

    setCcemail(prev => mergeUnique(prev, formattedCandidates))
    setCcemailSelected(prev => mergeUnique(prev, formattedCandidates))
    setCcemailSearched(prev => mergeUnique(prev, formattedCandidates))
    setCcemailall(prev => mergeUnique(prev, formattedCandidates))
    setCcemailjobsall(prev => mergeUnique(prev, formattedCandidates))
    setCcemailjobsSearched(prev => mergeUnique(prev, formattedCandidates))
    setCcemailjobssear(prev => mergeUnique(prev, formattedCandidates))

    setLinkCanccVisible(false)
    setSelectedCancc([]) // Clear selected candidates
    setSearchText("") // Clear search text
  }

  const handleRefresh1cc = () => {
    setSelectedCancc([]) // Reset selected contacts
    setSearchText("") // Reset search text
  }

  useEffect(() => {
    if (signatureOptions.length > 0 && !selectedSignature) {
      const defaultSig = signatureOptions.find(
        signature => signature.is_default
      )
      if (defaultSig) {
        setSelectedSignature(defaultSig)
        setSignatureText(defaultSig.signature_text || "")
      }
    }
  }, [signatureOptions])

  useEffect(() => {
    gettemplateitems()
    getsignatureitems()
    fetchFromMails()
  }, [])
  const onPageChange = event => {
    setLazyParams({ page: event.page, rows: event.rows })
  }

  const sendNewMail = async () => {
    const newErrors = {}

    // Validate From email
    if (
      !fromemailjobsSelectedTo ||
      fromemailjobsSelectedTo.length === 0 ||
      !fromemailjobsSelectedTo[0]?.trim()
    ) {
      newErrors.from = "From email is required"
    }

    // Validate To email (only for non-All dialogs)
    if (!emailviewpopAll && !jobsallpopup) {
      let toEmails = []
      if (jobsselectedpopup) {
        toEmails = toemailseljobs // Use toemailseljobs for Jobs Selected dialog
      } else if (jobssearchedpopup) {
        toEmails = toemailsearchjobs // Use toemailsearchjobs for Jobs Searched dialog
      } else {
        toEmails = toemailSelected // Use toemailSelected for other dialogs
      }

      if (
        !toEmails ||
        toEmails.length === 0 ||
        toEmails.every(email => !email?.trim())
      ) {
        newErrors.to = "To address is required"
      }
    }

    // Validate Subject
    // if (!subject?.trim()) {
    //   newErrors.subject = "Subject is required"
    // }

    // Validate Email Body
    const bodyToValidate =
      jobsallpopup || jobssearchedpopup || jobsselectedpopup
        ? jobDescriptions
        : emailtextEditor
    if (!bodyToValidate?.trim() || bodyToValidate === "<p><br></p>") {
      newErrors.body = "Email body is required"
    }

    // If there are validation errors, set them and stop
    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors)
      return
    }

    try {
      setFormErrors({})
      setIsLoading(true)

      const payload = {
        from_address: fromemailjobsSelectedTo[0], // Single email for from_address
        to_addresses:
          emailviewpopAll || jobsallpopup
            ? ["All Contacts"]
            : jobsselectedpopup
            ? toemailseljobs.filter(email => email?.trim())
            : jobssearchedpopup
            ? toemailsearchjobs.filter(email => email?.trim())
            : toemailSelected.filter(email => email?.trim()),
        cc_addresses: (jobsallpopup ? ccemailjobsall : ccemailSelected).filter(
          email => email?.trim()
        ), // Use ccemailjobsall for Jobs All
        subject: subject,
        body:
          jobsallpopup || jobssearchedpopup || jobsselectedpopup
            ? jobDescriptions
            : emailtextEditor,
        attachments: attachmentfile || [],
        is_private: privateChecked,
      }

      const response = await axios.post("/api/v1/emails/", payload)

      if (response.status === 201) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.data.message || "Email sent successfully",
        })

        // Close all dialogs
        SetEmailviewpop(false)
        SetEmailviewpopSelected(false)
        SetEmailviewpopSearched(false)
        SetEmailviewpopAll(false)
        SetJobsallPopup(false)
        SetJobssearchedPopup(false)
        SetJobsselectedPopup(false)

        // Reset all form fields
        setFrominputemail("")
        setFromemailjobsSelectedTo([])
        setFromemailjobs([])
        setTonewemail([])
        setToemailSelected([])
        setToemailSearched([])
        setFromemailAll([])
        setToemailjobs([])
        setToemailseljobs([])
        setToemailsearchjobs([])
        setCcemail([])
        setCcemailSelected([])
        setCcemailSearched([])
        setCcemailall([])
        setCcemailjobsall([])
        setCcemailjobsSearched([])
        setCcemailjobssear([])
        setSubject("")
        setEmailtextEditor(`
        <p>Dear {{contact_name}}</p>
        <br />
        <p></p>
        <br />
        <p>[Email Body]</p>
        <br />
        <p>We look forward to your response.</p>
        <br />
        ${defaultSignature}
      `)
        setJobDescriptions("")
        setSelectedJobs([])
        setAttachmentfile([])
        setSelectedTemplate("")
        setSelectedSignature("")
        setPrivateChecked(false)
        setFormErrors({})
        setSelectedCanto([])
        setSelectedCancc([])
        if (fileUploadRef.current) {
          fileUploadRef.current.clear()
        }
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.data.message || "Error sending email",
        })
      }
    } catch (err) {
      console.error(err)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong",
      })
    } finally {
      setIsLoading(false)
    }
  }

  const templateAbortController = useRef(null)
  const signatureAbortController = useRef(null)

  const handleTemplateChange = async e => {
    const templateId = e.value?.id

    // Cancel previous template request
    if (templateAbortController.current) {
      templateAbortController.current.abort()
    }
    templateAbortController.current = new AbortController()
    const { signal } = templateAbortController.current

    try {
      if (!templateId) {
        setSelectedTemplate(null)
        setTemplateBody("")
        return
      }

      const response = await axios.get(
        `/api/v1/email-templates/${templateId}/`,
        { signal }
      )
      if (response?.data) {
        const { body } = response.data
        setSelectedTemplate(e.value)
        setTemplateBody(body || "No Body Template is There!")
      }
    } catch (error) {
      if (error.name === "AbortError") return // Ignore aborted requests
      console.error("Error fetching template:", error)
      setSelectedTemplate(null)
      setTemplateBody("")
    }
  }
  const selectedEmailTemplate1 = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-envelope mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }
  const emailOptionTemplate1 = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  const removeFile = fileName => {
    setAttachmentfile(
      attachmentfile.filter(file => file.file_name !== fileName)
    )
  }

  const getAllSmPtvaluesprimary = async () => {
    try {
      const response = await axios.get(
        `/api/v1/smtp-accounts/by-primary/?is_primary=true`
      )

      // API returns a single object
      const primaryData = response.data

      if (primaryData[0] && primaryData[0].from_email) {
        const temp = {
          email: primaryData[0].from_email,
          id: primaryData[0].smtp_id,
        }
        setFrominputemail(temp)
        setPrimaryFromEmail(temp.email)
        setFromemailjobs([temp.email])
        setFromemailjobsSelectedTo([temp.email])
        setFromemailAll([temp.email])
      }
    } catch (error) {
      console.error("Error fetching primary SMTP account", error)
    }
  }
  useEffect(() => {
    getAllSmPtvaluesprimary()
  }, [])

      const handleSendMail = async() => {
    if (!subject || subject.trim() === "") {
      setShowNoSubjectConfirm(true);
      return;
    }
    await sendNewMail();
  };
    const handleConfirmSend = async() => {
    setShowNoSubjectConfirm(false);
    await sendNewMail();
  };

  const handleCancelSend = () => {
    setShowNoSubjectConfirm(false);
  };
  

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <CascadeSelect
        // value={selectedActEmail}
        onChange={handleEmailChange}
        options={actEmailOptions}
        optionLabel="name"
        optionGroupLabel="name"
        optionGroupChildren={["subItems"]}
        className="md:w-8rem me-1 ms-1"
        placeholder="Email"
      />

      <div className="d-none">
        {/* New email start */}
        <div>
          <Dialog
            header="New Email To Contact"
            visible={emailviewpop}
            className="interview-popup"
            style={{ width: "75vw", height: "82%" }}
            maximizable
            modal
            onHide={() => {
              SetEmailviewpop(false)
              setPrivateChecked(false)
              setFrominputemail(primaryFromEmail) // <-- Reset to primary
              setFromemailjobs([primaryFromEmail])
              setFromemailjobsSelectedTo([primaryFromEmail])
              setFromemailAll([primaryFromEmail])
              // Reset all form fields
              // setFromemailjobsSelectedTo([primaryFromEmail]);
              // setFromemailjobs([]); // Reset to default user email
              setTonewemail([])
              setCcemail([])
              setSubject("")

              setEmailtextEditor(`
        <p>Dear {{contact_name}},</p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        ${defaultSignature}
      `)
              // Reset all CC-related states
              setCcemail([])
              setCcemailSelected([])
              setCcemailSearched([])
              setCcemailall([])
              setCcemailjobsall([])
              setCcemailjobsSearched([])
              setCcemailjobssear([])

              setAttachmentfile([])
              setSelectedTemplate("")
              // Reset selectedSignature to the default signature if it exists
              const defaultSig = signatureOptions.find(
                signature => signature.is_default
              )
              setSelectedSignature(defaultSig || null)
              // setSelectedSignature("");
              setFormErrors({})
            }}
            footer={footerContent}
          >
            <Row>
              <div className="popup-header-bg">
                <Col lg={12}>
                  <div className="d-flex">
                    <Dropdown
                      value={selectedTemplate}
                      onChange={handleTemplateChange}
                      options={templateOptions}
                      placeholder="Template"
                      valueTemplate={selectedEmailTemplate1}
                      itemTemplate={emailOptionTemplate1}
                      className="w-full md:w-10rem action-items me-1"
                      dropdownIcon={opts => {
                        return opts.iconProps["data-pr-overlay-visible"] ? (
                          <ChevronRightIcon {...opts.iconProps} />
                        ) : (
                          <ChevronDownIcon {...opts.iconProps} />
                        )
                      }}
                    />
                    <Dropdown
                      value={selectedSignature}
                      onChange={handleSignatureChange}
                      options={signatureOptions}
                      optionLabel="label"
                      placeholder="Signature"
                      valueTemplate={selectedSmsTemplate}
                      itemTemplate={smsOptionTemplate}
                      className="w-full md:w-10rem action-items me-1"
                      dropdownIcon={opts => {
                        return opts.iconProps["data-pr-overlay-visible"] ? (
                          <ChevronRightIcon {...opts.iconProps} />
                        ) : (
                          <ChevronDownIcon {...opts.iconProps} />
                        )
                      }}
                    />
                    <div className="d-inline-block">
                      <FileUpload
                        name="emailAttachments[]"
                        ref={fileUploadRef}
                        url={"/api/upload"}
                        mode="basic"
                        multiple
                        accept="image/*,application/pdf"
                        maxFileSize={10000000}
                        auto
                        chooseLabel={<span>Attach File</span>}
                        customUpload
                        uploadHandler={onUploadHandler1}
                        className="me-2"
                      />
                    </div>
                    <Button
                      className="preview-btn ms-auto"
                      onClick={handleSendMail}
                      disabled={isLoading}
                    >
                      <i className="pi pi-send me-1"></i>{" "}
                      {isLoading ? "Sending..." : "Send"}
                    </Button>
                  </div>
                </Col>
              </div>
            </Row>

            <div className="bg-form form-insidepop">
              <Row className="mb-2">
                <Col xl={12}>
                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail}
                          onChange={e => {
                            const selected = e?.value?.code
                            setFrominputemail(selected)
                            setFromemailjobsSelectedTo([selected])
                            setFromemailjobs([selected])
                          }}
                          options={fromEmail}
                          optionLabel="name"
                          placeholder="From"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={fromemailjobs}
                        onChange={e => {
                          const newEntry = e.value[e.value.length - 1]
                          setFromemailjobs([newEntry])
                        }}
                        itemTemplate={Fromemailcont}
                        className="size-mail w-full"
                      />
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {formErrors.from}
                      </p>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail1}
                          onClick={e => {
                            e.preventDefault()
                            setLinkCantoVisible(true)
                          }}
                          optionLabel="name"
                          placeholder="To"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={tonewemail}
                        onChange={e => setTonewemail(e.value)}
                        className="size-mail w-full"
                      />
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {formErrors.to}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail2}
                          onClick={e => {
                            e.preventDefault()
                            setLinkCanccVisible(true)
                          }}
                          optionLabel="name"
                          placeholder="Cc"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={ccemail}
                        onChange={e => setCcemail(e.value)}
                        itemTemplate={Ccemailcont}
                        className="size-mail w-full"
                      />
                    </Col>
                  </Row>

                  <Row className="size-mail">
                    <Col xl={1}>
                      <label htmlFor="interview">Subject:</label>
                    </Col>
                    <Col xl={11}>
                      <InputText
                        id="interview"
                        aria-describedby="username-help"
                        placeholder=""
                        className="w-full"
                        value={subject}
                        onChange={e => setSubject(e.target.value)}
                      />
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {formErrors.subject}
                      </p>
                    </Col>
                  </Row>

                  {attachmentfile.length > 0 && (
                    <Row className="size-mail mt-2 align-items-baseline">
                      <Col xl={1}>
                        <label>Attached:</label>
                      </Col>
                      <Col xl={11}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            ref={fileListRef}
                            style={{
                              display: "flex",
                              overflowX: "auto",
                              whiteSpace: "nowrap",
                              maxWidth: "100%",
                              padding: "10px 0px",
                              borderRadius: "4px",
                            }}
                          >
                            {attachmentfile.map((file, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "15px",
                                  padding: "5px 10px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  background: "#f9f9f9",
                                  boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                                }}
                              >
                                <i
                                  className="pi pi-file"
                                  style={{ marginRight: "5px" }}
                                ></i>
                                <span>{file.file_name}</span>
                                <i
                                  className="pi pi-times"
                                  style={{
                                    marginLeft: "8px",
                                    cursor: "pointer",
                                    color: "#ff0000",
                                  }}
                                  onClick={() => removeFile(file.file_name)}
                                ></i>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>

              <Row>
                <Col xl={12}>
                  <p style={{ color: "red", fontSize: "13px" }}>
                    {formErrors.body}
                  </p>
                  <Editor
                    value={emailtextEditor}
                    onTextChange={e => setEmailtextEditor(e.htmlValue)}
                    className="editorpage"
                  />
                </Col>
              </Row>
            </div>
          </Dialog>
        </div>
        {/* New email end */}

        {selectedCustomers && selectedCustomers.length > 0 ? (
          <div>
            <Dialog
              header="Emails to Selected Contact"
              visible={emailviewpopSelected}
              className="interview-popup"
              style={{ width: "75vw", height: "82%" }}
              maximizable
              modal
              onHide={() => {
                SetEmailviewpopSelected(false)
                // Reset all form fields
                setFrominputemail(primaryFromEmail) // <-- Reset to primary
                setFromemailjobs([primaryFromEmail])
                setFromemailjobsSelectedTo([primaryFromEmail])
                setFromemailAll([primaryFromEmail])
                setTonewemail([])
                // Reset From email
                setToemailSelected([]) // Reset To email
                setCcemailSelected([]) // Reset CC email
                setSubject("") // Reset Subject
                setEmailtextEditor(`
            <p>Dear {{contact_name}}</p>
            <br />
            <p></p>
            <br />
            <p></p>
            <br />
            <p></p>
            <br />
            ${defaultSignature}
          `) // Reset email body
                setAttachmentfile([]) // Reset attachments
                // Reset all CC-related states
                setCcemail([])
                setCcemailSelected([])
                setCcemailSearched([])
                setCcemailall([])
                setCcemailjobsall([])
                setCcemailjobsSearched([])
                setCcemailjobssear([])
                setSelectedTemplate("") // Reset template
                // Reset selectedSignature to the default signature if it exists
                const defaultSig = signatureOptions.find(
                  signature => signature.is_default
                )
                setSelectedSignature(defaultSig || null)
                setPrivateChecked(false) // Reset private checkbox
                setFormErrors({}) // Reset form errors
              }}
              footer={footerContent}
            >
              <Row>
                <div className="popup-header-bg">
                  <Col lg={12} className="d-flex align-items-center">
                    <Dropdown
                      value={selectedTemplate}
                      onChange={handleTemplateChange}
                      options={templateOptions}
                      placeholder="Template"
                      valueTemplate={selectedEmailTemplate1}
                      itemTemplate={emailOptionTemplate1}
                      className="w-full md:w-10rem me-2"
                      dropdownIcon={opts => {
                        return opts.iconProps["data-pr-overlay-visible"] ? (
                          <ChevronRightIcon {...opts.iconProps} />
                        ) : (
                          <ChevronDownIcon {...opts.iconProps} />
                        )
                      }}
                    />
                    <Dropdown
                      value={selectedSignature}
                      onChange={handleSignatureChange}
                      options={signatureOptions}
                      optionLabel="label"
                      placeholder="Signature"
                      valueTemplate={selectedSmsTemplate}
                      itemTemplate={smsOptionTemplate}
                      className="w-full md:w-10rem me-2"
                      dropdownIcon={opts => {
                        return opts.iconProps["data-pr-overlay-visible"] ? (
                          <ChevronRightIcon {...opts.iconProps} />
                        ) : (
                          <ChevronDownIcon {...opts.iconProps} />
                        )
                      }}
                    />
                    <div className="d-inline-block">
                      <FileUpload
                        name="emailAttachments[]"
                        ref={fileUploadRef}
                        url={"/api/upload"}
                        mode="basic"
                        multiple
                        accept="image/*,application/pdf"
                        maxFileSize={5000000}
                        auto
                        chooseLabel={<span>Attach File</span>}
                        customUpload
                        uploadHandler={onUploadHandler1}
                        className="me-2"
                      />
                    </div>
                    <Button
                      className="preview-btn ms-auto"
                      onClick={handleSendMail}
                      disabled={isLoading}
                    >
                      <i className="pi pi-send me-1"></i>{" "}
                      {isLoading ? "Sending..." : "Send"}
                    </Button>
                  </Col>
                </div>
              </Row>

              <div className="bg-form form-insidepop">
                <Row className="mb-2">
                  <Col xl={12}>
                    <Row>
                      <Col xl={1} className="pe-0 mb-1">
                        <div className="label-input">
                          <Dropdown
                            value={frominputemail}
                            onChange={e => {
                              const selected = e?.value?.code
                              setFrominputemail(selected)
                              setFromemailjobsSelectedTo([selected])
                            }}
                            options={fromEmail}
                            optionLabel="name"
                            placeholder="From"
                            className="from-width w-full"
                          />
                        </div>
                      </Col>
                      <Col xl={11} className="mb-1">
                        <Chips
                          value={fromemailjobsSelectedTo}
                          onChange={e => {
                            const newEntry = e.value[e.value.length - 1]
                            setFromemailjobsSelectedTo([newEntry])
                          }}
                          itemTemplate={Fromemailcont}
                          className="size-mail w-full"
                        />
                        <p style={{ color: "red", fontSize: "13px" }}>
                          {formErrors.from}
                        </p>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={1} className="pe-0 mb-1">
                        <div className="label-input">
                          <Dropdown
                            value={frominputemail1}
                            onClick={e => {
                              e.preventDefault()
                              setLinkCantoVisible(true)
                            }}
                            optionLabel="name"
                            placeholder="To"
                            className="from-width w-full"
                          />
                        </div>
                      </Col>
                      <Col xl={11} className="mb-1">
                        <Chips
                          value={toemailSelected}
                          onChange={e => setToemailSelected(e.value)}
                          className="size-mail w-full"
                        />
                        <p style={{ color: "red", fontSize: "13px" }}>
                          {formErrors.to}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={1} className="pe-0 mb-1">
                        <div className="label-input">
                          <Dropdown
                            value={frominputemail2}
                            onClick={e => {
                              e.preventDefault()
                              setLinkCanccVisible(true)
                            }}
                            optionLabel="name"
                            placeholder="Cc"
                            className="from-width w-full"
                          />
                        </div>
                      </Col>
                      <Col xl={11} className="mb-1">
                        <Chips
                          value={ccemailSelected}
                          onChange={e => setCcemailSelected(e.value)}
                          itemTemplate={Ccemailcont}
                          className="size-mail w-full"
                        />
                      </Col>
                    </Row>

                    <Row className="size-mail">
                      <Col xl={1}>
                        <label htmlFor="interview">Subject:</label>
                      </Col>
                      <Col xl={11}>
                        <InputText
                          id="interview"
                          aria-describedby="username-help"
                          placeholder=""
                          className="w-full"
                          value={subject}
                          onChange={e => setSubject(e.target.value)}
                        />
                        <p style={{ color: "red", fontSize: "13px" }}>
                          {formErrors.subject}
                        </p>
                      </Col>
                    </Row>

                    {attachmentfile.length > 0 && (
                      <Row className="size-mail mt-2 align-items-baseline">
                        <Col xl={1}>
                          <label>Attached:</label>
                        </Col>
                        <Col xl={11}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div
                              ref={fileListRef}
                              style={{
                                display: "flex",
                                overflowX: "auto",
                                whiteSpace: "nowrap",
                                maxWidth: "100%",
                                padding: "10px 0px",
                                borderRadius: "4px",
                              }}
                            >
                              {attachmentfile.map((file, index) => (
                                <div
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginRight: "15px",
                                    padding: "5px 10px",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    background: "#f9f9f9",
                                    boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                                  }}
                                >
                                  <i
                                    className="pi pi-file"
                                    style={{ marginRight: "5px" }}
                                  ></i>
                                  <span>{file.file_name}</span>
                                  <i
                                    className="pi pi-times"
                                    style={{
                                      marginLeft: "8px",
                                      cursor: "pointer",
                                      color: "#ff0000",
                                    }}
                                    onClick={() => removeFile(file.file_name)}
                                  ></i>
                                </div>
                              ))}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col xl={12}>
                    <p style={{ color: "red", fontSize: "13px" }}>
                      {formErrors.body}
                    </p>
                    <Editor
                      value={emailtextEditor}
                      onTextChange={e => setEmailtextEditor(e.htmlValue)}
                      className="editorpage"
                    />
                  </Col>
                </Row>
              </div>
            </Dialog>
          </div>
        ) : (
          <Dialog
            header="No Contacts Selected"
            visible={emailviewpopSelected}
            style={{ width: "30vw" }}
            modal
            onHide={() => SetEmailviewpopSelected(false)}
            footer={
              <div>
                <Button
                  label="OK"
                  icon="pi pi-check"
                  onClick={() => SetEmailviewpopSelected(false)}
                  className="p-button-primary"
                />
              </div>
            }
          >
            <div className="p-2">
              <p>Please select at least one contact to send emails.</p>
            </div>
          </Dialog>
        )}

        {/* New email searched start */}
        <div>
          <Dialog
            header="Emails to Searched Contacts"
            visible={emailviewpopSearched}
            className="interview-popup"
            style={{ width: "75vw", height: "82%" }}
            maximizable
            modal
            onHide={() => {
              SetEmailviewpopSearched(false)
              // Reset all form fields
              setFrominputemail(primaryFromEmail) // <-- Reset to primary
              setFromemailjobs([primaryFromEmail])
              setFromemailjobsSelectedTo([primaryFromEmail])
              setFromemailAll([primaryFromEmail])
              setToemailSearched([])
              setCcemailSearched([])
              setSubject("")
              // Reset all CC-related states
              setCcemail([])
              setCcemailSelected([])
              setCcemailSearched([])
              setCcemailall([])
              setCcemailjobsall([])
              setCcemailjobsSearched([])
              setCcemailjobssear([])
              setEmailtextEditor(`
        <p>Dear {{contact_name}}</p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        <p></p>
        <br />
        ${defaultSignature}
      `)
              setAttachmentfile([])
              setSelectedTemplate("")
              // Reset selectedSignature to the default signature if it exists
              const defaultSig = signatureOptions.find(
                signature => signature.is_default
              )
              setSelectedSignature(defaultSig || null)
              setPrivateChecked(false)
              setFormErrors({})
              // Reset candidate selections
              setSelectedCanto([])
              setSelectedCancc([])
              // Clear file upload component
              if (fileUploadRef.current) {
                fileUploadRef.current.clear()
              }
            }}
            footer={footerContent}
          >
            <Row>
              <div className="popup-header-bg">
                <Col lg={12} className="d-flex align-items-center">
                  <Dropdown
                    value={selectedTemplate}
                    onChange={handleTemplateChange}
                    options={templateOptions}
                    placeholder="Template"
                    valueTemplate={selectedEmailTemplate1}
                    itemTemplate={emailOptionTemplate1}
                    className="w-full md:w-10rem me-2"
                    dropdownIcon={opts => {
                      return opts.iconProps["data-pr-overlay-visible"] ? (
                        <ChevronRightIcon {...opts.iconProps} />
                      ) : (
                        <ChevronDownIcon {...opts.iconProps} />
                      )
                    }}
                  />
                  <Dropdown
                    value={selectedSignature}
                    onChange={handleSignatureChange}
                    options={signatureOptions}
                    optionLabel="label"
                    placeholder="Signature"
                    valueTemplate={selectedSmsTemplate}
                    itemTemplate={smsOptionTemplate}
                    className="w-full md:w-10rem me-2"
                    dropdownIcon={opts => {
                      return opts.iconProps["data-pr-overlay-visible"] ? (
                        <ChevronRightIcon {...opts.iconProps} />
                      ) : (
                        <ChevronDownIcon {...opts.iconProps} />
                      )
                    }}
                  />
                  <div className="d-inline-block">
                    <FileUpload
                      name="emailAttachments[]"
                      ref={fileUploadRef}
                      url={"/api/upload"}
                      mode="basic"
                      multiple
                      accept="image/*,application/pdf"
                      maxFileSize={5000000}
                      auto
                      chooseLabel={<span>Attach File</span>}
                      customUpload
                      uploadHandler={onUploadHandler1}
                      className="me-2"
                    />
                  </div>
                  <Button
                    className="preview-btn ms-auto"
                    onClick={handleSendMail}
                    disabled={isLoading}
                  >
                    <i className="pi pi-send me-1"></i>{" "}
                    {isLoading ? "Sending..." : "Send"}
                  </Button>
                </Col>
              </div>
            </Row>

            <div className="bg-form form-insidepop">
              <Row className="mb-2">
                <Col xl={12}>
                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail}
                          onChange={e => {
                            const selected = e?.value?.code
                            setFrominputemail(selected)
                            setFromemailjobsSelectedTo([selected])
                          }}
                          options={fromEmail}
                          optionLabel="name"
                          placeholder="From"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={fromemailjobsSelectedTo}
                        onChange={e => {
                          const newEntry = e.value[e.value.length - 1]
                          setFromemailjobsSelectedTo([newEntry])
                        }}
                        itemTemplate={Fromemailcont}
                        className="size-mail w-full"
                      />
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {formErrors.from}
                      </p>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail1}
                          onClick={e => {
                            e.preventDefault()
                            setLinkCantoVisible(true)
                          }}
                          optionLabel="name"
                          placeholder="To"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={toemailSearched}
                        onChange={e => setToemailSearched(e.value)}
                        className="size-mail w-full"
                      />
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {formErrors.to}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail2}
                          onClick={e => {
                            e.preventDefault()
                            setLinkCanccVisible(true)
                          }}
                          optionLabel="name"
                          placeholder="Cc"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={ccemailSearched}
                        onChange={e => setCcemailSearched(e.value)}
                        itemTemplate={Ccemailcont}
                        className="size-mail w-full"
                      />
                    </Col>
                  </Row>

                  <Row className="size-mail">
                    <Col xl={1}>
                      <label htmlFor="interview">Subject:</label>
                    </Col>
                    <Col xl={11}>
                      <InputText
                        id="interview"
                        aria-describedby="username-help"
                        placeholder=""
                        className="w-full"
                        value={subject}
                        onChange={e => setSubject(e.target.value)}
                      />
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {formErrors.subject}
                      </p>
                    </Col>
                  </Row>

                  {attachmentfile.length > 0 && (
                    <Row className="size-mail mt-2 align-items-baseline">
                      <Col xl={1}>
                        <label>Attached:</label>
                      </Col>
                      <Col xl={11}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            ref={fileListRef}
                            style={{
                              display: "flex",
                              overflowX: "auto",
                              whiteSpace: "nowrap",
                              maxWidth: "100%",
                              padding: "10px 0px",
                              borderRadius: "4px",
                            }}
                          >
                            {attachmentfile.map((file, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "15px",
                                  padding: "5px 10px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  background: "#f9f9f9",
                                  boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                                }}
                              >
                                <i
                                  className="pi pi-file"
                                  style={{ marginRight: "5px" }}
                                ></i>
                                <span>{file.file_name}</span>
                                <i
                                  className="pi pi-times"
                                  style={{
                                    marginLeft: "8px",
                                    cursor: "pointer",
                                    color: "#ff0000",
                                  }}
                                  onClick={() => removeFile(file.file_name)}
                                ></i>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>

              <Row>
                <Col xl={12}>
                  <p style={{ color: "red", fontSize: "13px" }}>
                    {formErrors.body}
                  </p>
                  <Editor
                    value={emailtextEditor}
                    onTextChange={e => setEmailtextEditor(e.htmlValue)}
                    className="editorpage"
                  />
                </Col>
              </Row>
            </div>
          </Dialog>
        </div>
        {/* New email searched end */}

        {/* New email All start */}
        <div>
          <Dialog
            header="Emails to All Contacts"
            visible={emailviewpopAll}
            className="interview-popup"
            style={{ width: "75vw", height: "82%" }}
            maximizable
            modal
            onHide={() => {
              SetEmailviewpopAll(false)
              setPrivateChecked(false)
              setFrominputemail(primaryFromEmail) // <-- Reset to primary
              setFromemailjobs([primaryFromEmail])
              setFromemailjobsSelectedTo([primaryFromEmail])
              setFromemailAll([primaryFromEmail])
              setTonewemail([])
              setCcemail([])
              setSubject("")
              setEmailtextEditor(`
            <p>Dear {{contact_name}},</p>
            <br />
            <p></p>
            <br />
            <p></p>
            <br />
            <p></p>
            <br />
            ${defaultSignature}
        `)
              setAttachmentfile([])
              // Reset all CC-related states
              setCcemail([])
              setCcemailSelected([])
              setCcemailSearched([])
              setCcemailall([])
              setCcemailjobsall([])
              setCcemailjobsSearched([])
              setCcemailjobssear([])
              setSelectedTemplate("")
              // Reset selectedSignature to the default signature if it exists
              const defaultSig = signatureOptions.find(
                signature => signature.is_default
              )
              setSelectedSignature(defaultSig || null)
              setFormErrors({})
              setCcemailSelected([])
            }}
            footer={footerContent}
          >
            <Row>
              <div className="popup-header-bg">
                <Col lg={12} className="d-flex align-items-center">
                  <Dropdown
                    value={selectedTemplate}
                    onChange={handleTemplateChange}
                    options={templateOptions}
                    placeholder="Template"
                    valueTemplate={selectedEmailTemplate1}
                    itemTemplate={emailOptionTemplate1}
                    className="w-full md:w-10rem me-2"
                    dropdownIcon={opts => {
                      return opts.iconProps["data-pr-overlay-visible"] ? (
                        <ChevronRightIcon {...opts.iconProps} />
                      ) : (
                        <ChevronDownIcon {...opts.iconProps} />
                      )
                    }}
                  />
                  <Dropdown
                    value={selectedSignature}
                    onChange={handleSignatureChange}
                    options={signatureOptions}
                    optionLabel="label"
                    placeholder="Signature"
                    valueTemplate={selectedSmsTemplate}
                    itemTemplate={smsOptionTemplate}
                    className="w-full md:w-10rem me-2"
                    dropdownIcon={opts => {
                      return opts.iconProps["data-pr-overlay-visible"] ? (
                        <ChevronRightIcon {...opts.iconProps} />
                      ) : (
                        <ChevronDownIcon {...opts.iconProps} />
                      )
                    }}
                  />
                  <div className="d-inline-block">
                    <FileUpload
                      name="emailAttachments[]"
                      ref={fileUploadRef}
                      url={"/api/upload"}
                      mode="basic"
                      multiple
                      accept="image/*,application/pdf"
                      maxFileSize={10000000}
                      auto
                      chooseLabel={<span>Attach File</span>}
                      customUpload
                      uploadHandler={onUploadHandler1}
                      className="me-2"
                    />
                  </div>
                  <Button
                    className="preview-btn ms-auto"
                    onClick={handleSendMail}
                    disabled={isLoading}
                  >
                    <i className="pi pi-send me-1"></i>{" "}
                    {isLoading ? "Sending..." : "Send"}
                  </Button>
                </Col>
              </div>
            </Row>
            <div className="bg-form form-insidepop">
              <Row className="mb-2">
                <Col xl={12}>
                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail}
                          onChange={e => {
                            const selected = e?.value?.code
                            setFrominputemail(selected)
                            setFromemailjobsSelectedTo([selected])
                            setFromemailjobs([selected])
                          }}
                          options={fromEmail}
                          optionLabel="name"
                          placeholder="From"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={fromemailjobs}
                        onChange={e => {
                          const newEntry = e.value[e.value.length - 1]
                          setFromemailjobs([newEntry])
                        }}
                        itemTemplate={Fromemailcont}
                        className="size-mail w-full"
                      />
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {formErrors.from}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail1}
                          onClick={e => {
                            e.preventDefault()
                          }}
                          optionLabel="name"
                          placeholder="To"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={["All Contacts "]}
                        className="size-mail w-full"
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail2}
                          onClick={e => {
                            e.preventDefault()
                            setLinkCanccVisible(true)
                          }}
                          optionLabel="name"
                          placeholder="Cc"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={ccemailall}
                        onChange={e => setCcemailall(e.value)}
                        itemTemplate={Ccemailcont}
                        className="size-mail w-full"
                      />
                    </Col>
                  </Row>
                  <Row className="size-mail">
                    <Col xl={1}>
                      <label htmlFor="interview">Subject:</label>
                    </Col>
                    <Col xl={11}>
                      <InputText
                        id="interview"
                        aria-describedby="username-help"
                        placeholder=""
                        className="w-full"
                        value={subject}
                        onChange={e => setSubject(e.target.value)}
                      />
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {formErrors.subject}
                      </p>
                    </Col>
                  </Row>
                  {attachmentfile.length > 0 && (
                    <Row className="size-mail mt-2 align-items-baseline">
                      <Col xl={1}>
                        <label>Attached:</label>
                      </Col>
                      <Col xl={11}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            ref={fileListRef}
                            style={{
                              display: "flex",
                              overflowX: "auto",
                              whiteSpace: "nowrap",
                              maxWidth: "100%",
                              padding: "10px 0px",
                              borderRadius: "4px",
                            }}
                          >
                            {attachmentfile.map((file, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "15px",
                                  padding: "5px 10px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  background: "#f9f9f9",
                                  boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                                }}
                              >
                                <i
                                  className="pi pi-file"
                                  style={{ marginRight: "5px" }}
                                ></i>
                                <span>{file.file_name}</span>
                                <i
                                  className="pi pi-times"
                                  style={{
                                    marginLeft: "8px",
                                    cursor: "pointer",
                                    color: "#ff0000",
                                  }}
                                  onClick={() => removeFile(file.file_name)}
                                ></i>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
              <Row>
                <Col xl={12}>
                  <p style={{ color: "red", fontSize: "13px" }}>
                    {formErrors.body}
                  </p>
                  <Editor
                    value={emailtextEditor}
                    onTextChange={e => setEmailtextEditor(e.htmlValue)}
                    className="editorpage"
                  />
                </Col>
              </Row>
            </div>
          </Dialog>
        </div>
        {/* New email All end */}

        {/* jobs all start */}
        <Dialog
          header="Send an Email to Contact with All Jobs"
          visible={jobsallpopup}
          className="interview-popup"
          onHide={() => {
            SetJobsallPopup(false)
            setSelectedTemplate(null) // Clear selected template
            setTemplateBody("") // Clear template body

            setSignatureText("") // Clear signature text
            // Reset other dialog-specific states
            setFrominputemail(primaryFromEmail) // <-- Reset to primary
            setFromemailjobs([primaryFromEmail])
            setFromemailjobsSelectedTo([primaryFromEmail])
            setFromemailAll([primaryFromEmail])
            setToemailjobs([])
            setCcemailjobsall([])
            setSelectedJobs([])
            setSubject("")
            setAttachmentfile([])
            setPrivateChecked(false)
            setFormErrors({})
            setSelectedCanto([])
            setSelectedCancc([])
            if (fileUploadRef.current) {
              fileUploadRef.current.clear()
            }
            const defaultSig = signatureOptions.find(
              signature => signature.is_default
            )
            setSelectedSignature(defaultSig || null)
            setJobDescriptions(`
      <p>Dear {{contact_name}}</p>
      <br />
      <p></p>
      <br />
      <p></p>
      <br />
      ${defaultSignature}
    `)
            handleSave() // Update jobDescriptions with no template, preserving signature
          }}
          style={{ width: "75vw", height: "82%" }}
          maximizable
          modal
          footer={footerContent}
        >
          <Row>
            <div className="popup-header-bg">
              <Col lg={12} className="d-flex align-items-center">
                <Dropdown
                  value={selectedTemplate}
                  onChange={handleTemplateChange}
                  options={templateOptions}
                  placeholder="Template"
                  valueTemplate={selectedEmailTemplate1}
                  itemTemplate={emailOptionTemplate1}
                  className="w-full md:w-10rem me-2"
                  dropdownIcon={opts =>
                    opts.iconProps["data-pr-overlay-visible"] ? (
                      <ChevronRightIcon {...opts.iconProps} />
                    ) : (
                      <ChevronDownIcon {...opts.iconProps} />
                    )
                  }
                />
                <Dropdown
                  value={selectedSignature}
                  onChange={handleSignatureChange}
                  options={signatureOptions}
                  optionLabel="label"
                  placeholder="Signature"
                  valueTemplate={selectedSmsTemplate}
                  itemTemplate={smsOptionTemplate}
                  className="w-full md:w-10rem me-2"
                  dropdownIcon={opts =>
                    opts.iconProps["data-pr-overlay-visible"] ? (
                      <ChevronRightIcon {...opts.iconProps} />
                    ) : (
                      <ChevronDownIcon {...opts.iconProps} />
                    )
                  }
                />
                <div className="d-inline-block">
                  <FileUpload
                    name="emailAttachments[]"
                    ref={fileUploadRef}
                    url={"/api/upload"}
                    mode="basic"
                    multiple
                    accept="image/*,application/pdf"
                    maxFileSize={10000000}
                    auto
                    chooseLabel={<span>Attach File</span>}
                    customUpload
                    uploadHandler={onUploadHandler1}
                    className="me-2"
                  />
                </div>
                <Button
                  className="preview-btn ms-auto"
                  onClick={handleSendMail}
                  disabled={isLoading}
                >
                  <i className="pi pi-send me-1"></i>{" "}
                  {isLoading ? "Sending..." : "Send"}
                </Button>
              </Col>
            </div>
          </Row>

          <div className="bg-form form-insidepop">
            <Row className="mb-2">
              <Col xl={12}>
                <Row className="mb-2">
                  <Col xl={1} className="pe-0">
                    <div className="label-input">
                      <Dropdown
                        value={frominputemail}
                        onChange={e => {
                          const selected = e?.value?.code
                          setFrominputemail(selected)
                          setFromemailjobs([selected])
                          setFromemailjobsSelectedTo([selected])
                        }}
                        options={fromEmail}
                        optionLabel="name"
                        placeholder="From"
                        className="from-width w-full"
                      />
                    </div>
                  </Col>
                  <Col xl={11}>
                    <Chips
                      value={fromemailjobs}
                      onChange={e => {
                        const newEntry = e.value[e.value.length - 1]
                        setFromemailjobs([newEntry])
                        setFromemailjobsSelectedTo([newEntry])
                      }}
                      itemTemplate={Fromemailcontjobs}
                      className="size-mail w-full"
                    />
                    <p style={{ color: "red", fontSize: "13px" }}>
                      {formErrors.from}
                    </p>
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col xl={1} className="pe-0">
                    <div className="label-input">
                      <Dropdown
                        value={frominputemail1}
                        onClick={e => {
                          e.preventDefault()
                        }}
                        optionLabel="name"
                        placeholder="To"
                        className="from-width w-full"
                      />
                    </div>
                  </Col>
                  <Col xl={11}>
                    <Chips
                      value={["All Contacts"]}
                      className="size-mail w-full"
                      disabled
                    />
                  </Col>
                </Row>

                <Row className="mb-2">
                  <Col xl={1} className="pe-0">
                    <div className="label-input">
                      <Dropdown
                        value={frominputemail2}
                        onClick={e => {
                          e.preventDefault()
                          setLinkCanccVisible(true)
                        }}
                        optionLabel="name"
                        placeholder="Cc"
                        className="from-width w-full"
                      />
                    </div>
                  </Col>
                  <Col xl={11}>
                    <Chips
                      value={ccemailjobsall}
                      onChange={e => setCcemailjobsall(e.value)}
                      itemTemplate={Ccemailcontjobs}
                      className="size-mail w-full"
                    />
                  </Col>
                </Row>

                <Row className="size-mail mb-1">
                  <Col xl={1}>
                    <label htmlFor="interview">Subject:</label>
                  </Col>
                  <Col xl={11}>
                    <InputText
                      id="interview"
                      aria-describedby="username-help"
                      placeholder=""
                      className="w-full"
                      value={subject}
                      onChange={e => setSubject(e.target.value)}
                    />
                    <p style={{ color: "red", fontSize: "13px" }}>
                      {formErrors.subject}
                    </p>
                  </Col>
                </Row>

                {attachmentfile.length > 0 && (
                  <Row className="size-mail mt-2 align-items-baseline">
                    <Col xl={1}>
                      <label>Attached:</label>
                    </Col>
                    <Col xl={11}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          ref={fileListRef}
                          style={{
                            display: "flex",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                            padding: "10px 0px",
                            borderRadius: "4px",
                          }}
                        >
                          {attachmentfile.map((file, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginRight: "15px",
                                padding: "5px 10px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                background: "#f9f9f9",
                                boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                              }}
                            >
                              <i
                                className="pi pi-file"
                                style={{ marginRight: "5px" }}
                              ></i>
                              <span>{file.file_name}</span>
                              <i
                                className="pi pi-times"
                                style={{
                                  marginLeft: "8px",
                                  cursor: "pointer",
                                  color: "#ff0000",
                                }}
                                onClick={() => removeFile(file.file_name)}
                              ></i>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>

            <Row>
              <Col xl={12}>
                <p style={{ color: "red", fontSize: "13px" }}>
                  {formErrors.body}
                </p>
                <Editor
                  value={jobDescriptions}
                  onTextChange={e => setJobDescriptions(e.htmlValue)}
                  className="jobsall-editor"
                />
              </Col>
            </Row>
          </div>
        </Dialog>

        <Dialog
          header="Job Details"
          visible={jobDetailsVisible}
          onHide={() => {
            setJobDetailsVisible(false)
            setSearchText("")
          }}
          style={{ width: "40vw" }}
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
          className="cand-details"
        >
          {/* Search Bar */}
          <Row>
            <Col lg={12}>
              <div
                className="p-inputgroup mb-3"
                style={{ position: "relative" }}
              >
                <InputText
                  placeholder="Search Jobs"
                  value={searchText}
                  onInput={e => setSearchText(e.target.value)}
                  style={{ paddingRight: "2rem" }} // Space for the icon
                />
                <i
                  className="pi pi-search"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "49%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
              </div>
            </Col>
          </Row>

          {/* DataTable */}
          <DataTable
            value={filteredJobs}
            paginator
            rows={jobsLazyParams.rows}
            first={jobsLazyParams.page * jobsLazyParams.rows}
            totalRecords={totalJobsRecords}
            onPage={onJobsPageChange}
            selection={selectedJobs}
            onSelectionChange={e => setSelectedJobs(e.value)}
            dataKey="job_id"
            rowsPerPageOptions={[5, 10, 25]}
            size="small"
          >
            <Column selectionMode="multiple" style={{ width: "3em" }} />
            <Column field="job_number" header="Job ID" />
            <Column field="job_title" header="Job Title" />
            <Column field="hiring_manager_name" header="Contact" />
          </DataTable>

          {/* Actions */}
          <div className="d-flex mt-3">
            <button
              type="button"
              className="btn btn-primary me-2 btn-main"
              onClick={() => {
                handleSave()
                setJobDetailsVisible(false)
                setSearchText("")
              }}
            >
              Ok
            </button>
            <button
              type="button"
              className="btn btn-primary btn-main"
              onClick={handleRefresh}
            >
              Refresh
            </button>
          </div>
        </Dialog>
        {/* jobs all end */}

        {/* Jobs Searched Start */}
        <Dialog
          header="Send a Email to Contact with Searched Jobs"
          visible={jobssearchedpopup}
          className="interview-popup"
          style={{ width: "75vw", height: "82%" }}
          maximizable
          modal
          onHide={() => {
            SetJobssearchedPopup(false)
            setSelectedTemplate(null) // Clear selected template
            setTemplateBody("") // Clear template body

            setSignatureText("") // Clear signature text
            // Reset other dialog-specific states
            setFrominputemail(primaryFromEmail) // <-- Reset to primary
            setFromemailjobs([primaryFromEmail])
            setFromemailjobsSelectedTo([primaryFromEmail])
            setFromemailAll([primaryFromEmail])
            setToemailsearchjobs([])
            setCcemailjobsSearched([])
            setSubject("")
            setSelectedJobs([])
            setJobDescriptions(`
      <p>Dear {{contact_name}},</p>
      <br />
      <p></p>
      <br />
      <p></p>
      <br />
      ${defaultSignature}
    `)
            setAttachmentfile([])
            const defaultSig = signatureOptions.find(
              signature => signature.is_default
            )
            setSelectedSignature(defaultSig || null)
            setPrivateChecked(false)
            setFormErrors({})
            setSelectedCanto([])
            setSelectedCancc([])
            if (fileUploadRef.current) {
              fileUploadRef.current.clear()
            }
          }}
          footer={footerContent}
        >
          <Row>
            <div className="popup-header-bg">
              <Col lg={12} className="d-flex align-items-center">
                <Dropdown
                  value={selectedTemplate}
                  onChange={handleTemplateChange}
                  options={templateOptions}
                  placeholder="Template"
                  valueTemplate={selectedEmailTemplate1}
                  itemTemplate={emailOptionTemplate1}
                  className="w-full md:w-10rem me-2"
                  dropdownIcon={opts =>
                    opts.iconProps["data-pr-overlay-visible"] ? (
                      <ChevronRightIcon {...opts.iconProps} />
                    ) : (
                      <ChevronDownIcon {...opts.iconProps} />
                    )
                  }
                />
                <Dropdown
                  value={selectedSignature}
                  onChange={handleSignatureChange}
                  options={signatureOptions}
                  optionLabel="label"
                  placeholder="Signature"
                  valueTemplate={selectedSmsTemplate}
                  itemTemplate={smsOptionTemplate}
                  className="w-full md:w-10rem me-2"
                  dropdownIcon={opts =>
                    opts.iconProps["data-pr-overlay-visible"] ? (
                      <ChevronRightIcon {...opts.iconProps} />
                    ) : (
                      <ChevronDownIcon {...opts.iconProps} />
                    )
                  }
                />
                <div className="d-inline-block">
                  <FileUpload
                    name="emailAttachments[]"
                    ref={fileUploadRef}
                    url={"/api/upload"}
                    mode="basic"
                    multiple
                    accept="image/*,application/pdf"
                    maxFileSize={10000000}
                    auto
                    chooseLabel={<span>Attach File</span>}
                    customUpload
                    uploadHandler={onUploadHandler1}
                    className="me-2"
                  />
                </div>
                <Button
                  className="preview-btn ms-auto"
                  onClick={handleSendMail}
                  disabled={isLoading}
                >
                  <i className="pi pi-send me-1"></i>{" "}
                  {isLoading ? "Sending..." : "Send"}
                </Button>
              </Col>
            </div>
          </Row>

          <div className="bg-form form-insidepop">
            <Row className="mb-2">
              <Col xl={12}>
                <Row>
                  <Col xl={1} className="pe-0 mb-1">
                    <div className="label-input">
                      <Dropdown
                        value={frominputemail}
                        onChange={e => {
                          const selected = e?.value?.code
                          setFrominputemail(selected)
                          setFromemailjobsSelectedTo([selected])
                        }}
                        options={fromEmail}
                        optionLabel="name"
                        placeholder="From"
                        className="from-width w-full"
                      />
                    </div>
                  </Col>
                  <Col xl={11} className="mb-1">
                    <Chips
                      value={fromemailjobsSelectedTo}
                      onChange={e => {
                        const newEntry = e.value[e.value.length - 1]
                        setFromemailjobsSelectedTo([newEntry])
                      }}
                      itemTemplate={Fromemailcont}
                      className="size-mail w-full"
                    />
                    <p style={{ color: "red", fontSize: "13px" }}>
                      {formErrors.from}
                    </p>
                  </Col>
                </Row>

                <Row>
                  <Col xl={1} className="pe-0 mb-1">
                    <div className="label-input">
                      <Dropdown
                        value={frominputemail1}
                        onClick={e => {
                          e.preventDefault()
                          setLinkCantoVisible(true)
                        }}
                        optionLabel="name"
                        placeholder="To"
                        className="from-width w-full"
                      />
                    </div>
                  </Col>
                  <Col xl={11} className="mb-1">
                    <Chips
                      value={toemailsearchjobs}
                      onChange={e => setToemailsearchjobs(e.value)}
                      className="size-mail w-full"
                    />
                    <p style={{ color: "red", fontSize: "13px" }}>
                      {formErrors.to}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col xl={1} className="pe-0 mb-1">
                    <div className="label-input">
                      <Dropdown
                        value={frominputemail2}
                        onClick={e => {
                          e.preventDefault()
                          setLinkCanccVisible(true)
                        }}
                        optionLabel="name"
                        placeholder="Cc"
                        className="from-width w-full"
                      />
                    </div>
                  </Col>
                  <Col xl={11} className="mb-1">
                    <Chips
                      value={ccemailjobsSearched}
                      onChange={e => setCcemailjobsSearched(e.value)}
                      itemTemplate={Ccemailcont}
                      className="size-mail w-full"
                    />
                  </Col>
                </Row>

                <Row className="size-mail">
                  <Col xl={1}>
                    <label htmlFor="interview">Subject:</label>
                  </Col>
                  <Col xl={11}>
                    <InputText
                      id="interview"
                      aria-describedby="username-help"
                      placeholder=""
                      className="w-full"
                      value={subject}
                      onChange={e => setSubject(e.target.value)}
                    />
                    <p style={{ color: "red", fontSize: "13px" }}>
                      {formErrors.subject}
                    </p>
                  </Col>
                </Row>

                {attachmentfile.length > 0 && (
                  <Row className="size-mail mt-2 align-items-baseline">
                    <Col xl={1}>
                      <label>Attached:</label>
                    </Col>
                    <Col xl={11}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          ref={fileListRef}
                          style={{
                            display: "flex",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                            padding: "10px 0px",
                            borderRadius: "4px",
                          }}
                        >
                          {attachmentfile.map((file, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginRight: "15px",
                                padding: "5px 10px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                background: "#f9f9f9",
                                boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                              }}
                            >
                              <i
                                className="pi pi-file"
                                style={{ marginRight: "5px" }}
                              ></i>
                              <span>{file.file_name}</span>
                              <i
                                className="pi pi-times"
                                style={{
                                  marginLeft: "8px",
                                  cursor: "pointer",
                                  color: "#ff0000",
                                }}
                                onClick={() => removeFile(file.file_name)}
                              ></i>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>

            <Row>
              <Col xl={12}>
                <p style={{ color: "red", fontSize: "13px" }}>
                  {formErrors.body}
                </p>
                <Editor
                  value={jobDescriptions}
                  onTextChange={e => setJobDescriptions(e.htmlValue)}
                  className="jobsall-editor"
                />
              </Col>
            </Row>
          </div>
        </Dialog>
        {/* Jobs Searched End */}

        {/* jobs selected start */}

        {selectedCustomers && selectedCustomers.length > 0 ? (
          <Dialog
            header="Send a Email to Contact with Selected jobs"
            visible={jobsselectedpopup}
            className="interview-popup"
            style={{ width: "75vw", height: "82%" }}
            maximizable
            modal
            onHide={() => {
              SetJobsselectedPopup(false)
              setSelectedTemplate(null) // Clear selected template
              setTemplateBody("") // Clear template body
              const defaultSig = signatureOptions.find(
                signature => signature.is_default
              )
              setSelectedSignature(defaultSig || null)
              setSignatureText("") // Clear signature text
              // Reset other dialog-specific states
              setFrominputemail(primaryFromEmail) // <-- Reset to primary
              setFromemailjobs([primaryFromEmail])
              setFromemailjobsSelectedTo([primaryFromEmail])
              setFromemailAll([primaryFromEmail])
              setToemailseljobs([])
              setCcemailjobssear([])
              setSubject("")
              setSelectedJobs([])
              setJobDescriptions(`
      <p>Dear {{contact_name}},</p>
      <br />
      <p></p>
      <br />
      <p></p>
      <br />
      ${defaultSignature}
    `)
              setAttachmentfile([])
              setPrivateChecked(false)
              setFormErrors({})
              setSelectedCanto([])
              setSelectedCancc([])
              if (fileUploadRef.current) {
                fileUploadRef.current.clear()
              }
            }}
            footer={footerContent}
          >
            <Row>
              <div className="popup-header-bg">
                <Col lg={12} className="d-flex align-items-center">
                  <Dropdown
                    value={selectedTemplate}
                    onChange={handleTemplateChange}
                    options={templateOptions}
                    placeholder="Template"
                    valueTemplate={selectedEmailTemplate1}
                    itemTemplate={emailOptionTemplate1}
                    className="w-full md:w-10rem me-2"
                    dropdownIcon={opts =>
                      opts.iconProps["data-pr-overlay-visible"] ? (
                        <ChevronRightIcon {...opts.iconProps} />
                      ) : (
                        <ChevronDownIcon {...opts.iconProps} />
                      )
                    }
                  />
                  <Dropdown
                    value={selectedSignature}
                    onChange={handleSignatureChange}
                    options={signatureOptions}
                    optionLabel="label"
                    placeholder="Signature"
                    valueTemplate={selectedSmsTemplate}
                    itemTemplate={smsOptionTemplate}
                    className="w-full md:w-10rem me-2"
                    dropdownIcon={opts =>
                      opts.iconProps["data-pr-overlay-visible"] ? (
                        <ChevronRightIcon {...opts.iconProps} />
                      ) : (
                        <ChevronDownIcon {...opts.iconProps} />
                      )
                    }
                  />
                  <div className="d-inline-block">
                    <FileUpload
                      name="emailAttachments[]"
                      ref={fileUploadRef}
                      url={"/api/upload"}
                      mode="basic"
                      multiple
                      accept="image/*,application/pdf"
                      maxFileSize={10000000}
                      auto
                      chooseLabel={<span>Attach File</span>}
                      customUpload
                      uploadHandler={onUploadHandler1}
                      className="me-2"
                    />
                  </div>
                  <Button
                    className="preview-btn ms-auto"
                    onClick={handleSendMail}
                    disabled={isLoading}
                  >
                    <i className="pi pi-send me-1"></i>{" "}
                    {isLoading ? "Sending..." : "Send"}
                  </Button>
                </Col>
              </div>
            </Row>

            <div className="bg-form form-insidepop">
              <Row className="mb-2">
                <Col xl={12}>
                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail}
                          onChange={e => {
                            const selected = e?.value?.code
                            setFrominputemail(selected)
                            setFromemailjobs([selected])
                            setFromemailjobsSelectedTo([selected])
                          }}
                          options={fromEmail}
                          optionLabel="name"
                          placeholder="From"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={fromemailjobsSelectedTo}
                        onChange={e => {
                          const newEntry = e.value[e.value.length - 1]
                          setFromemailjobsSelectedTo([newEntry])
                          setFrominputemail(
                            fromEmail.find(opt => opt.code === newEntry) || ""
                          )
                        }}
                        itemTemplate={Fromemailcont}
                        className="size-mail w-full"
                      />
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {formErrors.from}
                      </p>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail1}
                          onClick={e => {
                            e.preventDefault()
                            setLinkCantoVisible(true)
                          }}
                          optionLabel="name"
                          placeholder="To"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={toemailseljobs}
                        onChange={e => setToemailseljobs(e.value)}
                        className="size-mail w-full"
                      />
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {formErrors.to}
                      </p>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl={1} className="pe-0 mb-1">
                      <div className="label-input">
                        <Dropdown
                          value={frominputemail2}
                          onClick={e => {
                            e.preventDefault()
                            setLinkCanccVisible(true)
                          }}
                          optionLabel="name"
                          placeholder="Cc"
                          className="from-width w-full"
                        />
                      </div>
                    </Col>
                    <Col xl={11} className="mb-1">
                      <Chips
                        value={ccemailjobssear}
                        onChange={e => setCcemailjobssear(e.value)}
                        itemTemplate={Ccemailcont}
                        className="size-mail w-full"
                      />
                    </Col>
                  </Row>

                  <Row className="size-mail">
                    <Col xl={1}>
                      <label htmlFor="interview">Subject:</label>
                    </Col>
                    <Col xl={11}>
                      <InputText
                        id="interview"
                        aria-describedby="username-help"
                        placeholder=""
                        className="w-full"
                        value={subject}
                        onChange={e => setSubject(e.target.value)}
                      />
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {formErrors.subject}
                      </p>
                    </Col>
                  </Row>

                  {attachmentfile.length > 0 && (
                    <Row className="size-mail mt-2 align-items-baseline">
                      <Col xl={1}>
                        <label>Attached:</label>
                      </Col>
                      <Col xl={11}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            ref={fileListRef}
                            style={{
                              display: "flex",
                              overflowX: "auto",
                              whiteSpace: "nowrap",
                              maxWidth: "100%",
                              padding: "10px 0px",
                              borderRadius: "4px",
                            }}
                          >
                            {attachmentfile.map((file, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginRight: "15px",
                                  padding: "5px 10px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  background: "#f9f9f9",
                                  boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                                }}
                              >
                                <i
                                  className="pi pi-file"
                                  style={{ marginRight: "5px" }}
                                ></i>
                                <span>{file.file_name}</span>
                                <i
                                  className="pi pi-times"
                                  style={{
                                    marginLeft: "8px",
                                    cursor: "pointer",
                                    color: "#ff0000",
                                  }}
                                  onClick={() => removeFile(file.file_name)}
                                ></i>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>

              <Row>
                <Col xl={12}>
                  <p style={{ color: "red", fontSize: "13px" }}>
                    {formErrors.body}
                  </p>
                  <Editor
                    value={jobDescriptions}
                    onTextChange={e => setJobDescriptions(e.htmlValue)}
                    className="jobsall-editor"
                  />
                </Col>
              </Row>
            </div>
          </Dialog>
        ) : (
          <Dialog
            header="No Jobs Selected"
            visible={jobsselectedpopup}
            style={{ width: "30vw" }}
            modal
            onHide={() => SetJobsselectedPopup(false)}
            footer={
              <div>
                <Button
                  label="OK"
                  icon="pi pi-check"
                  onClick={() => SetJobsselectedPopup(false)}
                  className="p-button-primary"
                />
              </div>
            }
          >
            <div className="p-2">
              <p>Please select at least one job to send emails.</p>
            </div>
          </Dialog>
        )}

        {/* jobs selected end */}

        {/* candidates popup to */}
        <Dialog
          header="Select Contact"
          visible={linkCantoVisible}
          onHide={() => {
            setLinkCantoVisible(false)
            setSelectedCanto([]) // Clear selected candidates
            setSearchText("") // Clear search text
          }}
          style={{ width: "40vw" }}
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
          className="cand-details"
        >
          {/* Search Bar */}
          <Row>
            <Col lg={12}>
              <div
                className="p-inputgroup mb-3"
                style={{ position: "relative" }}
              >
                <InputText
                  placeholder="Search Contacts..."
                  value={searchText}
                  onInput={e => setSearchText(e.target.value)}
                  style={{ paddingRight: "2rem" }}
                />
                <i
                  className="pi pi-search"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "49%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
              </div>
            </Col>
          </Row>

          {/* DataTable */}
          <DataTable
            key={selectedCanto.length} // Force re-render when selectedContacts changes
            value={filteredCanto(canto)}
            selection={selectedCanto}
            onSelectionChange={e => setSelectedCanto(e.value)}
            dataKey="id"
            size="small"
            lazy
            paginator
            first={lazyParams.page * lazyParams.rows}
            rows={lazyParams.rows}
            totalRecords={totalRecords}
            onPage={onPageChange}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            rowsPerPageOptions={[10, 20, 50, totalRecords]}
          >
            <Column selectionMode="multiple" style={{ width: "3em" }} />
            <Column
              header="Contact Name"
              body={rowData =>
                `${rowData.first_name || ""} ${rowData.last_name || ""}`
              }
            />
            <Column field="job_title" header="Designation" />
            <Column field="email" header="Email" />
          </DataTable>

          {/* Actions */}
          <div className="d-flex mt-3">
            <button
              type="button"
              className="btn btn-primary me-2 btn-main"
              onClick={handleSaveCanto}
            >
              Ok
            </button>
            <button
              type="button"
              className="btn btn-primary btn-main"
              onClick={handleRefresh1to}
            >
              Refresh
            </button>
          </div>
        </Dialog>

        {/* candidates popup cc */}
        <Dialog
          header="Select Contact"
          visible={linkCanccVisible}
          onHide={() => {
            setLinkCanccVisible(false)
            setSelectedCancc([]) // Clear selected candidates
            setSearchText("") // Clear search text
          }}
          style={{ width: "40vw" }}
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
          className="cand-details"
        >
          {/* Search Bar */}
          <Row>
            <Col lg={12}>
              <div
                className="p-inputgroup mb-3"
                style={{ position: "relative" }}
              >
                <InputText
                  placeholder="Search contact..."
                  value={searchText}
                  onInput={e => setSearchText(e.target.value)}
                  style={{ paddingRight: "2rem" }}
                />
                <i
                  className="pi pi-search"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "49%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
              </div>
            </Col>
          </Row>

          {/* DataTable */}
          <DataTable
            key={selectedCancc.length} // Force re-render when selectedContacts changes
            value={filteredCanto(canto)}
            selection={selectedCancc}
            onSelectionChange={e => setSelectedCancc(e.value)}
            dataKey="id"
            size="small"
            lazy
            paginator
            first={lazyParams.page * lazyParams.rows}
            rows={lazyParams.rows}
            totalRecords={totalRecords}
            onPage={onPageChange}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            rowsPerPageOptions={[10, 20, 50, totalRecords]}
          >
            <Column selectionMode="multiple" style={{ width: "3em" }} />
            <Column
              header="Contact Name"
              body={rowData =>
                `${rowData.first_name || ""} ${rowData.last_name || ""}`
              }
            />
            <Column field="job_title" header="Designation" />
            <Column field="email" header="Email" />
          </DataTable>

          {/* Actions */}
          <div className="d-flex mt-3">
            <button
              type="button"
              className="btn btn-primary me-2 btn-main"
              onClick={handleSaveCancc}
            >
              Ok
            </button>
            <button
              type="button"
              className="btn btn-primary btn-main"
              onClick={handleRefresh1cc}
            >
              Refresh
            </button>
          </div>
        </Dialog>
      </div>
      <Dialog
    header="No Subject"
    visible={showNoSubjectConfirm}
    style={{ width: "400px" }}
    modal
    onHide={handleCancelSend}
    footer={
      <div>
        <Button label="Yes, Send" className="btn btn-primary me-2" onClick={handleConfirmSend} />
        <Button label="Cancel" className="btn btn-secondary" onClick={handleCancelSend} />
      </div>
    }
  >
    <p>Do you want to send this email without a subject?</p>
  </Dialog>
    </React.Fragment>
  )
})

export default EmailContact
